export const LOAN_AUTOPAY_DAYS_BETWEEN_SEMI_MONTHLY_DRAFT_DATES = 15;
